import React from "react";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import Footer from "../components/footer/Footer";
import AIContactSection from "../components/ai-contact-section/AIContactSection";
import DevelopingSolution from "../components/developingsolution/DevelopingSolution";
import Testimonial from "../components/testimonila/Testimonial";
import HirePageBanner from "../components/HirePageBanner/HirePageBanner";
import PortFolioData from "../components/PortfolioData/PortFolioData";
import ContactSection from "../components/contactSection/ContactSection";
import { Helmet } from "react-helmet";
import { portfolioPageData } from "../data/portfolioPageData";
import { useTranslation } from "react-i18next";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import MegaMenu from "../components/MegaMenu/MegaMenu";

// The data object for the page

const Potfoliio = () => {
  // Access data from the object
  // const { banner, seo, developingSolution } = portfolioPageData;

  const { t } = useTranslation("portfolioPage");
  const banner = t("banner", { returnObjects: true });
  const seo = t("seo", { returnObjects: true });
  const developingSolution = t("developingSolution", { returnObjects: true });

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });
  // No need for var mainBannerImg = `url(/images/portfolio-banner-bg-image.png)`; anymore
  // since it's directly in the data object.

  return (
    <>
      <MegaMenu />
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
      </Helmet>
      <HirePageBanner
        diffBannerBackgroundImage={`url(${banner.backgroundImage})`} // Use template literal for URL
        mainHeading={banner.mainHeading}
        content={banner.content}
        contactUsLink={banner.contactUsLink}
        btnText={banner.buttonText}
      />
      <PortFolioData />{" "}
      {/* Assuming PortFolioData fetches its own data or needs no props here */}
      <DevelopingSolution heading={developingSolution.heading} />
      {/* <ContactSection /> Assuming ContactSection fetches its own data or needs no props here */}
      <SoftwareCompanyCta content={footerCtaContent} />
      <Footer />
    </>
  );
};

export default Potfoliio;
